/** UUID canônico — nunca aceitar um `external_id` no lugar do id do player. */
const UUID_CANONICO =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Se devemos trocar o `playerId` guardado pelo que o servidor resolveu no `hello`.
 *
 * <p><b>O caso que faltava.</b> Antes a adoção só valia quando NÃO havia playerId
 * guardado — "a frota já resolveu, nunca sobrescreve". Mas o id guardado pode estar
 * ERRADO, e aí a regra que protegia virava a que impedia o conserto: ele nunca mais
 * se corrige sozinho.</p>
 *
 * <p>Medido em produção em 2026-10-15: o player web do Renato tinha
 * `ad59fa2d-f314-40d1-9749-fcba91626d51` no `localStorage` — um id que responde
 * <b>404</b> no servidor. O player real é `555d3dc1…` ("Browser Renato"). O canal SSE
 * funcionava porque o servidor tolera o descompasso ("path stale — confiando no token
 * que resolve pra player 555d3dc1, cliente provavelmente tem playerId em cache antigo
 * após re-registration"), mas o player seguia mandando o ack de config para um
 * fantasma.</p>
 *
 * <p>Quem resolve o `hello` é o servidor, a partir do device token — ele é a
 * autoridade sobre qual player somos. Divergiu, o servidor vence.</p>
 */
export function devoAdotarPlayerId(
  atual: string | null | undefined,
  resolvidoPeloServidor: string | null | undefined,
): boolean {
  if (!resolvidoPeloServidor || !UUID_CANONICO.test(resolvidoPeloServidor)) {
    return false;
  }
  if (!atual) return true;
  return atual.toLowerCase() !== resolvidoPeloServidor.toLowerCase();
}
